import React, { useEffect, useState } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import { PageLayout } from "../src/FunctionalComponents/PageLayout";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import Header from "./FunctionalComponents/Header/Header";
import MyProfile from "./Pages/MyProfile/MyProfile";
import HomePage from "./Pages/HomePage/HomePage";
import NewHomePage from "./Pages/HomePage/NewHomePage";
import IgniteTalks from "./Pages/IgniteTalks/IgniteTalks";
import Admin from "./Pages/Admin/Admin";
import Footer from "./FunctionalComponents/Footer/Footer";

import Team from "Pages/Team/Team";
import { ComingSoon } from "./FunctionalComponents/ComingSoon";
// import LearningHubs from "./Pages/LearningHubs/LearningHubs";
import Testimonials from "./Pages/Testimonials/Testimonials";
// import { Dashboard } from "./FunctionalComponents/Dashboard";
import About from "./Pages/About/About";
import FAQ from "./Pages/FAQ";
import Dashboard from "./Pages/Dashboard";
import LearningHubsNew from "./Pages/LearningHubsNew";
import HallFame from "./Pages/HallFame";
import MainPage from "Components/MainPage";
import Iva from "Components/IgniteChat";
import IvaWidget from "Components/IvaWidget";

function App({ pca }) {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);

  pca.setNavigationClient(navigationClient);

  return (
    <MsalProvider instance={pca}>
      <PageLayout>
        <div container justifyContent="center">
          <Pages />
        </div>
      </PageLayout>
    </MsalProvider>
  );
}
function Pages() {
  const msalInstance = new PublicClientApplication(msalConfig);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  const fetchAccessToken = async () => {
    if (!activeAccount)
      throw Error(
        "No active account! Verify a user has been signed in and setActiveAccount has been called."
      );
    try {
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: activeAccount,
      });
      console.log("response from auth ", response);
      const bearer = `Bearer ${response.accessToken}`;
      localStorage.setItem("token", bearer);
      localStorage.setItem("user", response.account.username);
      localStorage.setItem("name", response.account.name);
    } catch (error) {
      console.error("Error fetching access token:", error);
      localStorage.clear();
    }
  };

  useEffect(() => {
    if (activeAccount) {
      fetchAccessToken();
    }
  }, [activeAccount]);

  // for ask iva popup
  const [ivaOpen, setIvaOpen] = useState(false);

  return (
    <>
      <Router basename="/">
        <Header />
        <IvaWidget isOpen={ivaOpen} setIsOpen={setIvaOpen} />
        <Switch>
          <Route exact path="/">
            <NewHomePage openIvaPopup={() => setIvaOpen(true)} />
          </Route>
          <Route exact path="/home">
            <NewHomePage openIvaPopup={() => setIvaOpen(true)} />
          </Route>
          <Route exact path="/learningHubs">
            <LearningHubsNew />
          </Route>
          <Route exact path="/dashboard">
            <Dashboard />
          </Route>
          <Route exact path="/igniteTalks">
            <IgniteTalks activeAccount={activeAccount} />
          </Route>
          <Route exact path="/admin">
            <Admin />
          </Route>
          <Route exact path="/team">
            <Team />
          </Route>
          <Route exact path="/topLearners">
            <ComingSoon />
          </Route>

          <Route exact path="/hallOfFame">
            <HallFame />
          </Route>
          <Route exact path="/testimonials">
            <Testimonials />
          </Route>
          <Route exact path="/aboutIgnite">
            <About />
          </Route>
          <Route exact path="/faq">
            <FAQ />
          </Route>
          <Route exact path="/prompttest">
            <MainPage />
          </Route>
          <Route exact path="/iva">
            <Iva />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </>
  );
}

export default App;
